/**
 * Removes characters and patterns that are unsafe for backend file paths
 * (e.g. path traversal and directory separators). Other characters are preserved.
 * `/` and `\` are replaced with `-`.
 */
export function sanitiseFileName(
  value: string | null | undefined,
  fallback = '',
): string {
  if (!value) return fallback;

  const sanitised = value
    .replace(/\0/g, '')
    .replace(/\.\./g, '')
    .replace(/[/\\]/g, '-');

  return sanitised || fallback;
}
